(function() {

  function initTimeline(section) {
    if (section.getAttribute('data-timeline-initialized')) return;
    section.setAttribute('data-timeline-initialized', 'true');

    var ticking = false;
    var steps = section.querySelector('.steps');
    var line = section.querySelector('.line');
    var items = section.querySelectorAll('.item');
    var lastItem = section.querySelector('.item.last');

    if (!steps || !line) return;

    function update() {
      var stepsRect = steps.getBoundingClientRect();
      var stepsTop = stepsRect.top + (window.pageYOffset || document.documentElement.scrollTop);
      var windowHeight = window.innerHeight || document.documentElement.clientHeight;
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      
      var triggerPoint = windowHeight / 2.75;
      var begin = stepsTop - windowHeight + triggerPoint;
      
      var endOffset = steps.offsetHeight;
      if (lastItem) {
        endOffset -= lastItem.offsetHeight;
      }
      var end = begin + endOffset + 2;
      
      var lineHeight = 0;
      if (scrollY >= begin && scrollY <= end) {
        lineHeight = scrollY - begin;
      } else if (scrollY > end) {
        lineHeight = end - begin;
      }
      
      line.style.height = lineHeight + 'px';

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var itemRect = item.getBoundingClientRect();
        var itemTop = itemRect.top + scrollY;
        var appearPoint = itemTop - windowHeight + triggerPoint;
        
        if (scrollY >= appearPoint) {
          item.classList.add('appear');
        } else {
          item.classList.remove('appear');
        }
      }
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function setupAllTimelines() {
    var sections = document.querySelectorAll('section.timeline-section');
    for (var i = 0; i < sections.length; i++) {
      initTimeline(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAllTimelines);
  } else {
    setupAllTimelines();
  }

  document.addEventListener('shopify:section:load', function(event) {
    setupAllTimelines();
  });
})();